import Enlang from './entries/en-US';
import Arlang from './entries/ar_SA';

const AppLocale = {
  en: Enlang,
  default: Arlang,
  ar: Arlang,
};

export default AppLocale;
